import { getEnterTimeout, getExitTimeout } from "../../reducers/methods";
import { setAnimationStatus } from "../animation";
import { StoreState } from "../../reducers";

export interface SetScreenNameAction {
  type: "SET_SCREEN_NAME";
  data: string;
}

export function setScreenName(screenName: string) {
  return async (dispatch: any, getState: any) => {
    const animationTimeout = getExitTimeout(getState() as StoreState);

    dispatch(setAnimationStatus("leaving"));
    await setTimeout(() => {
      dispatch({
        type: "SET_SCREEN_NAME",
        data: screenName,
      });
      const timeout = getEnterTimeout(getState() as StoreState);
      setTimeout(() => dispatch(setAnimationStatus("done")), timeout);
    }, animationTimeout);
  };
}
